(function(){
    'use strict';

    angular.module('app').controller('AccountingCaseManagementController', AccountingCaseManagementController);
    AccountingCaseManagementController.$inject = [
        'AccountingCaseManagementTableService'
    ];

    function AccountingCaseManagementController(
        AccountingCaseManagementTableService
    ){
        const vm = this;

        init();
        function init(){
            vm.disputeAndClaimsTable = new AccountingCaseManagementTableService().tableData;
        }
    }
})()


// WEBPACK FOOTER //
// ./js/controllers/accounting/AccountingCaseManagementController.js